import './style.scss';

function Footer() {
  return (
    <div className="footer">

      <div className="footer-link">
        FIT WORK
      </div>

    </div>
  );
}

export default Footer;
